// extracted by mini-css-extract-plugin
module.exports = {"contentHolder":"chargewallet_contentHolder__3nltP","FormHolder":"chargewallet_FormHolder__3wSHX","ButtonHolder":"chargewallet_ButtonHolder__v-m36"};